import { FC } from 'react'
import { MonitoringPanel } from '../../../MonitoringPanel'

export const StratificationQUsTopBanner: FC = () => {
  return (
    <MonitoringPanel.Alert severity="warning" variant="standard">
      <MonitoringPanel.Alert.Title>Verifique la información visible</MonitoringPanel.Alert.Title>
      <MonitoringPanel.Alert.Description>
        Una vez creado el Plan estas Unidades de cuantificación se bloquearán de forma permanente.
      </MonitoringPanel.Alert.Description>
    </MonitoringPanel.Alert>
  )
}
